import React from 'react';
import FormattedHelmet from "../../../cmp/intl/FormattedHelmet";
import LogoRender from "../../../cmp/LogoRender";
import AuthContainer from "../../../auth/components/AuthContainer";
import {post} from "../../../../api";
import Button from "../../../cmp/form/Button";

function UnsubscribePage() {
    const u = new URLSearchParams(document.location.search);
    const email = u.get('email');
    const contact_id = u.get('contact_id');
    const [status, setStatus] = React.useState('subscribed');
    const [loading, setLoading] = React.useState(false);
    const unSub = ()=>{
        setLoading(true)
        post('/extras/contact/subscription',{
            email,
            status: 'unsubscribed',
            contact_id,
        }).then(()=>{
            setLoading(false)
            setStatus('unsubscribed');

        })
    }
    const sub = ()=>{
        setLoading(true)
        post('/extras/contact/subscription',{
            email,
            status: 'subscribed',
            contact_id,
        }).then(()=>{
            setLoading(false)
            setStatus('subscribed');
        })
    }
    return (
        <AuthContainer>
            <FormattedHelmet id={'Unsubscribe'}/>
            <div className={'text-center mb-4'}>
                <LogoRender/>
            </div>
            <div className="card">
                <div className="card-body">
                    <h2>Unsubscribe</h2>
                    {
                        status === 'unsubscribed' ? <p>You have been unsubscribed from our email list. We're sorry to see you go! If this was a mistake, you can resubscribe at any time.</p> :
                            <p>Click the button below to unsubscribe from our email list.</p>
                    }
                    {/*<p>You have been unsubscribed from our email list. We're sorry to see you go! If this was a mistake, you can resubscribe at any time.</p>*/}
                    {
                        status === "unsubscribed" ? <>
                                <Button
                                    onClick={sub}
                                    loading={loading}
                                    className={"btn btn-secondary"}>Click here to resubscribe</Button>
                            </> :
                    <Button
                        onClick={unSub}
                        loading={loading}
                        className={"btn btn-secondary"}>Click here to unsubscribe</Button>
                    }
                </div>
            </div>
        </AuthContainer>
    );
}

export default UnsubscribePage;
